import { render, staticRenderFns } from "./DriverStatusIndicator.vue?vue&type=template&id=3320a986&scoped=true&"
import script from "./DriverStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./DriverStatusIndicator.vue?vue&type=script&lang=js&"
import style0 from "./DriverStatusIndicator.vue?vue&type=style&index=0&id=3320a986&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3320a986",
  null
  
)

export default component.exports